import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Popover } from 'antd';
import dayjs from 'dayjs';
import { EIconSize } from 'utils/constants/app/ui';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { createTestId } from 'utils/helpers/create-test-id';
import { GlobalIcon } from 'components/GlobalIcon';
import { getUser } from 'store/selectors/user-data';
import './index.less';

export const AccountInfo: FC = () => {
  const PopoverWrapperRef = useRef<HTMLDivElement>(null);
  const user = useSelector(getUser);
  const { t } = useTranslation();

  return (
    <div
      className="popoverWrapper"
      ref={PopoverWrapperRef}
      {...createTestId('popover-wrapper')}
    >
      <Popover
        trigger="click"
        placement="bottom"
        arrowPointAtCenter
        overlayStyle={{
          width: '100%',
          paddingLeft: 12,
          paddingRight: 12
        }}
        getPopupContainer={() => PopoverWrapperRef.current as HTMLDivElement}
        content={
          <>
            <div className="accountInfoRow">
              <span>{t('account.registrationDate')}</span>
              <span className="popoverWrapper_date">
                {user.reg_date
                  ? dayjs(user.reg_date).format(SpringConfigs.DT.longDate)
                  : '-'}
              </span>
            </div>
            <div className="accountInfoRow">
              <span>{t('account.lastLoginDate')}</span>
              <span className="popoverWrapper_date">
                {user.last_login_date
                  ? dayjs
                      .unix(user.last_login_date)
                      .format(SpringConfigs.DT.longDate)
                  : '-'}
              </span>
            </div>
            <div className="accountInfoRow">
              <span>{t('account.lastTermAndCondAcceptDate')}</span>
              <span className="popoverWrapper_date">
                {user.terms_and_conditions_acceptance_date
                  ? dayjs(user.terms_and_conditions_acceptance_date).format(
                      SpringConfigs.DT.longDate
                    )
                  : '-'}
              </span>
            </div>
          </>
        }
      >
        <GlobalIcon
          lib="generic"
          name="infoEM"
          theme="default"
          size={EIconSize._16}
          color="var(--v3-color-on-primary)"
          className="text-color"
        />
      </Popover>
    </div>
  );
};
